import Vue from 'vue';
import PortalVue from 'portal-vue';
//import './registerServiceWorker'
import store from './store.js';
import app from './app.js';
import appWrapper from './appWrapper.vue';
//global.app=app;
import config from '@/config.js';
import socket from './socket.js';
import file_definition from 'file_definition';
//import router from './router'
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.css';
import './assets/css/sidebar.css';
import './assets/css/ks_app.css';
import ks_ui from './components';
import mixins from './mixins';
import { VueMaskFilter } from 'v-mask';
import calendarDateFormat from './helpers/formatCalendarDateFilter';
import getUserContacts from './helpers/getUserContacts';
import getTimeZone from './helpers/getTimeZone';
import webPushNotification from './helpers/webPushNotifications';
import isMobile from './helpers/isMobile';
import validation from './helpers/validation';

//Define Global functions
global.app.store = store;
global.app.socket = socket;
global.app.name = config?.name || null;

global.app['dataproviders'] = {};

global.app['data'] = {
  getSource: source => {
    let aux = source.split('.');
    return { module: aux[0], crud: aux[1] };
  },
  getObject(inputs, _default = {}) {
    try {
      let obj = {};
      for (let input of inputs) {
        let value = typeof _default[input.name] !== 'undefined' ? _default[input.name] : null;
        obj[input.name] = value;
      }
      return obj;
    } catch (err) {
      return {};
    }
  },
  create: async (source = null, inputs = {}, files = [], delay = null) => {
    if (source && inputs) {
      const _source = global.app.data.getSource(source);
      const token = files && files.length > 0 ? global.app.auth.urlToken : global.app.auth.token;
      const res = await global.app.sdk[_source.module][`${_source.crud}_create`](token, inputs, true, files, delay);
      return res;
    } else {
      throw 'Invalid Source or Inputs';
    }
  },
  update: async (source = null, inputs = {}, files = [], delay = null) => {
    if (source && inputs) {
      const _source = global.app.data.getSource(source);
      const token = files && files.length > 0 ? global.app.auth.urlToken : global.app.auth.token;
      const res = await global.app.sdk[_source.module][`${_source.crud}_update`](token, inputs, true, files, delay);
      return res;
    } else {
      throw 'Invalid Source or Inputs';
    }
  },
  list: async (source = null, inputs = {}, delay = null) => {
    if (source && inputs) {
      const _source = global.app.data.getSource(source);
      const res = await global.app.sdk[_source.module][`${_source.crud}_list`](global.app.auth.token, inputs, true, [], delay);
      return res;
    } else {
      throw 'Invalid Source or Inputs';
    }
  },
  read: async (source = null, inputs = {}, delay = null) => {
    if (source && inputs) {
      const _source = global.app.data.getSource(source);
      const res = await global.app.sdk[_source.module][`${_source.crud}_read`](global.app.auth.token, inputs, true, [], delay);
      return res;
    } else {
      throw 'Invalid Source or Inputs';
    }
  },
  delete: async (source = null, inputs = {}, delay = null) => {
    if (source && inputs) {
      const _source = global.app.data.getSource(source);
      const res = await global.app.sdk[_source.module][`${_source.crud}_delete`](global.app.auth.token, inputs, true, [], delay);
      return res;
    } else {
      throw 'Invalid Source or Inputs';
    }
  },
  getCreateInputsObject: (source = null, _default = {}) => {
    if (source) {
      let _source = global.app.data.getSource(source);
      let inputs = global.app.sdk[_source.module][`${_source.crud}_create_inputs`];
      return global.app.getObject(inputs, _default);
    } else {
      throw 'Invalid Source';
    }
  },
  getUpdateInputsObject: (source = null, _default = {}) => {
    if (source) {
      let _source = global.app.data.getSource(source);
      let inputs = global.app.sdk[_source.module][`${_source.crud}_update_inputs`];
      return global.app.getObject(inputs, _default);
    } else {
      throw 'Invalid Source';
    }
  },
  getListInputsObject: (source = null, _default = {}) => {
    if (source) {
      let _source = global.app.data.getSource(source);
      let inputs = global.app.sdk[_source.module][`${_source.crud}_list_inputs`];
      return global.app.getObject(inputs, _default);
    } else {
      throw 'Invalid Source';
    }
  },
  getReadInputsObject: (source = null, _default = {}) => {
    if (source) {
      let _source = global.app.data.getSource(source);
      let inputs = global.app.sdk[_source.module][`${_source.crud}_read_inputs`];
      return global.app.getObject(inputs, _default);
    } else {
      throw 'Invalid Source';
    }
  },
  getDeleteInputsObject: (source = null, _default = {}) => {
    if (source) {
      let _source = global.app.data.getSource(source);
      let inputs = global.app.sdk[_source.module][`${_source.crud}_delete_inputs`];
      return global.app.getObject(inputs, _default);
    } else {
      throw 'Invalid Source';
    }
  },
};

//add notification function
global.app['playNotification'] = (name = 'wp') => {
  try {
    let audio = new Audio(require(`./assets/media/notification_sounds/${name}.mp3`));
    audio.play();
  } catch (err) {
    console.log('KS-APP playNotification: ', err);
  }
};

global.app['getUserContacts'] = getUserContacts;
global.app['getLocalTimeZone'] = getTimeZone;
global.app['webPushNotification'] = webPushNotification;
global.app['isMobile'] = isMobile;

global.app['encodeQueryStringParams'] = (obj = null) => {
  if (typeof obj === 'object' && obj !== null) {
    return btoa(JSON.stringify(obj));
  } else {
    return null;
  }
};

global.app['decodeQueryStringParams'] = (hash = null) => {
  if (hash && typeof hash === 'string') {
    return JSON.parse(atob(hash));
  } else {
    return null;
  }
};

global.app['message'] = (body = null, type = 'success', hideIn = null, closable = true) => {
  if (global.app['activePage']) {
    global.app.activePage.openAlert({
      body: body,
      type: type,
      hideIn: hideIn,
      closable: closable,
    });
  }
};

global.app['setMessage'] = (body = null, type = 'success', hideIn = null, closable = true) => {
  let alerts = window.localStorage.getItem(store.state.rms_ui.auth.auth.suffix + 'alerts');
  if (alerts) {
    alerts = JSON.parse(alerts);
    if (alerts && Array.isArray(alerts)) {
      alerts.push({
        body: body,
        type: type,
        hideIn: hideIn,
        closable: closable,
      });
      window.localStorage.setItem(store.state.rms_ui.auth.auth.suffix + 'alerts', JSON.stringify(alerts));
    }
  } else {
    window.localStorage.setItem(
      store.state.rms_ui.auth.auth.suffix + 'alerts',
      JSON.stringify([
        {
          body: body,
          type: type,
          hideIn: hideIn,
          closable: closable,
        },
      ])
    );
  }
};

global.app['toast'] = (body = null, type = 'success', hideIn = null, closable = true) => {
  if (global.app['activePage']) {
    global.app.activePage.openToast({
      body: body,
      type: type,
      autohide: hideIn,
      showClose: closable,
      closeTimer: hideIn
    });
  }
};

global.app['confirm'] = (title = null, body = null, buttons = []) => {
  return new Promise(async (resolve, reject) => {
    try {
      let res = null;
      if (global.app['activePage']) {
        if (buttons.length > 0) {
          res = await global.app.activePage.openConfirm(title, body, buttons);
        }
      }
      resolve(res);
    } catch (err) {
      reject(err);
    }
  });
};

global.app['closeConfirm'] = (title = null, body = null, buttons = []) => {
  if (global.app['activePage']) {
    global.app.activePage.closeConfirm();
  }
};

global.app['setToast'] = (body = null, type = 'success', hideIn = null, closable = true) => {
  let toasts = window.localStorage.getItem(store.state.rms_ui.auth.auth.suffix + 'toasts');
  if (toasts) {
    toasts = JSON.parse(toasts);
    if (toasts && Array.isArray(toasts)) {
      toasts.push({
        body: body,
        type: type,
        hideIn: hideIn,
        closable: closable,
      });
      window.localStorage.setItem(store.state.rms_ui.auth.auth.suffix + 'toasts', JSON.stringify(toasts));
    }
  } else {
    window.localStorage.setItem(
      store.state.rms_ui.auth.auth.suffix + 'toasts',
      JSON.stringify([
        {
          body: body,
          type: type,
          hideIn: hideIn,
          closable: closable,
        },
      ])
    );
  }
};

global.app['hasDataprovider'] = name => {
  return global.app.dataproviders.hasOwnProperty(name);
};

global.app['addDataprovider'] = (name, ref) => {
  if (!global.app.hasDataprovider(name)) global.app.dataproviders[name] = ref;
  else throw 'invalid dataprovider the key is used ' + [name];
};

global.app['getDataprovider'] = name => {
  return global.app.dataproviders[name];
};

global.app['getDefaultModeIdByDataProviderName'] = (dpName) => {
  let default_mode = global.app.auth.user.default_modes.find(mode => mode.data_provider_name === dpName);
  return default_mode.default_data_provider_mode_id;
};

global.app['getDefaultSearchModeIdByDataProviderName'] = (dpName) => {
  let default_mode = global.app.auth.user.default_modes.find(mode => mode.data_provider_name === dpName);
  return default_mode.default_search_data_provider_mode_id;
};

global.app['removeDataprovider'] = name => {
  return delete global.app.dataproviders[name];
};

global.app['formatCurrency'] = (amount, roundToTwoDecimals = true) => {
  let roundedAmount = roundToTwoDecimals ? (Math.floor(amount * 100).toFixed(0) / 100).toFixed(2) : amount;
  return '$' + roundedAmount.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',');
  // return typeof roundedAmount === 'String' ? '$' + parseInt(roundedAmount).toLocaleString() : '$' + roundedAmount.toLocaleString();
};


global.app['activateCampaign'] = campaign_id => {
  console.log(" global.app.auth.user.data_campaigns",  global.app.auth.user.data_campaigns);
  console.log("campaign_id", typeof campaign_id);
  global.app.auth.user.data_campaigns.forEach((campaign) => {
    console.log("campaign.id", campaign.id);
  })
  let foundCampaign = global.app.auth.user.data_campaigns.find(campaign => campaign.id === JSON.parse(campaign_id));
  console.log("foundCampaign", foundCampaign);
  if (foundCampaign) {
    let campaigns = JSON.parse(JSON.stringify(global.app.activeMultiCampaigns));
    campaigns.push(foundCampaign);
    // store.state.rms_ui.auth.dispatch('setSelectedCampaigns', campaigns);
    // store.commit('rms_ui/auth/setSelectedCampaigns', campaigns);


    store.dispatch('rms_ui/auth/setActiveMultiCampaigns', {
      campaigns:           campaigns,
      loadUserCurrentData: false,
    });
  }




    // store.state.rms_ui.auth.selected_campaigns;
};


global.app['abbreviatedIcons'] = icon => {
  switch (icon) {
    case 'ban':
      return 'fas fa-ban';
    case 'check':
      return 'fas fa-check';
    case 'search':
      return 'fas fa-search';
    case 'cog':
      return 'fas fa-cog';
    case 'share-alt':
      return 'fas fa-share-alt';
    case 'check-square':
      return 'far fa-check-square';
    case 'square':
      return 'far fa-square';
    case 'minus-square':
      return 'fas fa-minus-square';
    case 'plus-square':
      return 'fas fa-plus-square';
    case 'history':
      return 'fas fa-history';
    case 'user-alt-slash':
      return 'fas fa-user-alt-slash';
    case 'power-off':
      return 'fas fa-power-off';
    case 'plus':
      return 'fas fa-plus';
    case 'exclamation':
      return 'fas fa-exclamation';
    case 'tasks':
      return 'fas fa-tasks';
    case 'pencil-alt':
      return 'fas fa-pencil-alt';
    case 'phone':
      return 'fas fa-phone';
    case 'money-bill-alt':
      return 'far fa-money-bill-alt';
    case 'phone-volume':
      return 'fas fa-phone-volume';
    case 'print':
      return 'fas fa-print';
    case 'sticky-note':
      return 'fas fa-sticky-note';
    case 'voicemail':
      return 'fas fa-voicemail';
    case 'sms':
      return 'fas fa-sms';
    case 'truck-loading':
      return 'fas fa-truck-loading';
    case 'envelope':
      return 'fas fa-envelope';
    case 'lock':
      return 'fas fa-lock';
    case 'lock-open':
      return 'fas fa-lock-open';
    case 'list-ol':
      return 'fas fa-list-ol';
    case 'angle-right':
      return 'fas fa-angle-right';
    case 'angle-left':
      return 'fas fa-angle-left';
    case 'sync':
      return 'fas fa-sync';
  }
};

global.app['preDefinedDataSetObjects'] = {
  weekDayNames() {
    return [
      { value: 1, label: 'Monday' },
      { value: 2, label: 'Tuesday' },
      { value: 3, label: 'Wednesday' },
      { value: 4, label: 'Thursday' },
      { value: 5, label: 'Friday' },
      { value: 6, label: 'Saturday' },
      { value: 7, label: 'Sunday' },
    ];
  },
  daysInMonth: month => {
    return [
      { value: 1, label: '1' },
      { value: 2, label: '2' },
      { value: 3, label: '3' },
      { value: 4, label: '4' },
      { value: 5, label: '5' },
      { value: 6, label: '6' },
      { value: 7, label: '7' },
      { value: 8, label: '8' },
      { value: 9, label: '9' },
      { value: 10, label: '10' },
      { value: 11, label: '11' },
      { value: 12, label: '12' },
      { value: 13, label: '13' },
      { value: 14, label: '14' },
      { value: 15, label: '15' },
      { value: 16, label: '16' },
      { value: 17, label: '17' },
      { value: 18, label: '18' },
      { value: 19, label: '19' },
      { value: 20, label: '20' },
      { value: 21, label: '21' },
      { value: 22, label: '22' },
      { value: 23, label: '23' },
      { value: 24, label: '24' },
      { value: 25, label: '25' },
      { value: 26, label: '26' },
      { value: 27, label: '27' },
      { value: 28, label: '28' },
      { value: 29, label: '29' },
      { value: 30, label: '30' },
      { value: 31, label: '31' },
    ];
  },
  years: () => {},
  hours: () => {
    return [
      { value: '1', label: '1' },
      { value: '2', label: '2' },
      { value: '3', label: '3' },
      { value: '4', label: '4' },
      { value: '5', label: '5' },
      { value: '6', label: '6' },
      { value: '7', label: '7' },
      { value: '8', label: '8' },
      { value: '9', label: '9' },
      { value: '10', label: '10' },
      { value: '11', label: '11' },
      { value: '12', label: '12' },
    ];
  },
  minutes: () => {
    return [
      { value: '0', label: '00' },
      { value: '1', label: '01' },
      { value: '2', label: '02' },
      { value: '3', label: '03' },
      { value: '4', label: '04' },
      { value: '5', label: '05' },
      { value: '6', label: '06' },
      { value: '7', label: '07' },
      { value: '8', label: '08' },
      { value: '9', label: '09' },
      { value: '10', label: '10' },
      { value: '11', label: '11' },
      { value: '12', label: '12' },
      { value: '13', label: '13' },
      { value: '14', label: '14' },
      { value: '15', label: '15' },
      { value: '16', label: '16' },
      { value: '17', label: '17' },
      { value: '18', label: '18' },
      { value: '19', label: '19' },
      { value: '20', label: '20' },
      { value: '21', label: '21' },
      { value: '22', label: '22' },
      { value: '23', label: '23' },
      { value: '24', label: '24' },
      { value: '25', label: '25' },
      { value: '26', label: '26' },
      { value: '27', label: '27' },
      { value: '28', label: '28' },
      { value: '29', label: '29' },
      { value: '30', label: '30' },
      { value: '31', label: '31' },
      { value: '32', label: '32' },
      { value: '33', label: '33' },
      { value: '34', label: '34' },
      { value: '35', label: '35' },
      { value: '36', label: '36' },
      { value: '37', label: '37' },
      { value: '38', label: '38' },
      { value: '39', label: '39' },
      { value: '40', label: '40' },
      { value: '41', label: '41' },
      { value: '42', label: '42' },
      { value: '43', label: '43' },
      { value: '44', label: '44' },
      { value: '45', label: '45' },
      { value: '46', label: '46' },
      { value: '47', label: '47' },
      { value: '48', label: '48' },
      { value: '49', label: '49' },
      { value: '50', label: '50' },
      { value: '51', label: '51' },
      { value: '52', label: '52' },
      { value: '53', label: '53' },
      { value: '54', label: '54' },
      { value: '55', label: '55' },
      { value: '56', label: '56' },
      { value: '57', label: '57' },
      { value: '58', label: '58' },
      { value: '59', label: '59' },
    ];
  },
  seconds: () => {
    return [
      { value: 0, label: ':00' },
      { value: 1, label: ':01' },
      { value: 2, label: ':02' },
      { value: 3, label: ':03' },
      { value: 4, label: ':04' },
      { value: 5, label: ':05' },
      { value: 6, label: ':06' },
      { value: 7, label: ':07' },
      { value: 8, label: ':08' },
      { value: 9, label: ':09' },
      { value: 10, label: ':10' },
      { value: 11, label: ':11' },
      { value: 12, label: ':12' },
      { value: 13, label: ':13' },
      { value: 14, label: ':14' },
      { value: 15, label: ':15' },
      { value: 16, label: ':16' },
      { value: 17, label: ':17' },
      { value: 18, label: ':18' },
      { value: 19, label: ':19' },
      { value: 20, label: ':20' },
      { value: 21, label: ':21' },
      { value: 22, label: ':22' },
      { value: 23, label: ':23' },
      { value: 24, label: ':24' },
      { value: 25, label: ':25' },
      { value: 26, label: ':26' },
      { value: 27, label: ':27' },
      { value: 28, label: ':28' },
      { value: 29, label: ':29' },
      { value: 30, label: ':30' },
      { value: 31, label: ':31' },
      { value: 32, label: ':32' },
      { value: 33, label: ':33' },
      { value: 34, label: ':34' },
      { value: 35, label: ':35' },
      { value: 36, label: ':36' },
      { value: 37, label: ':37' },
      { value: 38, label: ':38' },
      { value: 39, label: ':39' },
      { value: 40, label: ':40' },
      { value: 41, label: ':41' },
      { value: 42, label: ':42' },
      { value: 43, label: ':43' },
      { value: 44, label: ':44' },
      { value: 45, label: ':45' },
      { value: 46, label: ':46' },
      { value: 47, label: ':47' },
      { value: 48, label: ':48' },
      { value: 49, label: ':49' },
      { value: 50, label: ':50' },
      { value: 51, label: ':51' },
      { value: 52, label: ':52' },
      { value: 53, label: ':53' },
      { value: 54, label: ':54' },
      { value: 55, label: ':55' },
      { value: 56, label: ':56' },
      { value: 57, label: ':57' },
      { value: 58, label: ':58' },
      { value: 59, label: ':59' },
    ];
  },
};

global.app.sdk.file = global.app.create_sdk(file_definition);
//define global validations
global.app['validation'] = validation;
global.app['showPreloader'] = false;

//Vue config and import ks_components
window.$ = window.jQuery = require('jquery');
global.app.io = 'todo';
Vue.config.productionTip = false;
for (let cp in ks_ui) {
  Vue.component(cp, ks_ui[cp]);
}
Vue.filter('mask', VueMaskFilter);
Vue.filter('calendarDateFormat', calendarDateFormat);
Vue.mixin(mixins.state);
Vue.use(PortalVue);
new Vue({
  store,
  //router,
  render: h => h(appWrapper),
}).$mount('#app');
